











import { Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class OrganizationIcon extends Vue {
  @Prop(Number) public avatarSize!: number;
  @Prop(String) public avatarColor!: string;
  @Prop(Boolean) public avatarTile!: boolean;
  @Prop(Number) public avatarWidth!: number;
}
